import { render, staticRenderFns } from "./WaitingForCardPaymentModal.vue?vue&type=template&id=178cb92e"
import script from "./WaitingForCardPaymentModal.vue?vue&type=script&lang=js"
export * from "./WaitingForCardPaymentModal.vue?vue&type=script&lang=js"
import style0 from "./WaitingForCardPaymentModal.vue?vue&type=style&index=0&id=178cb92e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports